/**
 * Sound player hook for playful theme effects.
 *
 * Uses react-sounds library for CDN-hosted, lazy-loaded sound effects.
 * No local MP3 files needed — sounds are fetched on demand.
 */

import { useCallback } from 'react';
import { playSound } from 'react-sounds';
import { SoundEffect } from './types';

export function useSoundPlayer() {
  const play = useCallback((effect: SoundEffect) => {
    playSound(effect.name, {
      volume: effect.volume,
      rate: effect.rate,
    }).catch(() => {
      // Swallow errors — sound is non-critical
    });
  }, []);

  return { play };
}
